import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { FirebaseFunctionsService, UsersService, UserAccountMapsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TResponse, TRole, TUser } from '@shared/models';

@Component({
    'selector': 'app-users',
    'templateUrl': './users.page.html',
    'styleUrls': ['./users.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class UsersPage extends ViewBasePage implements OnInit, OnDestroy {
    public users: any = [];
    private usersSubscription: any;
    public usersDefinedStr: string;

    constructor( private usersService: UsersService,
        private userAccountMapsService: UserAccountMapsService, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_USERS);
    }

    public override ngOnInit(): void {
        super.ngOnInit();

        const usersObservable = this.usersService.getObservable();
        this.usersSubscription = usersObservable.subscribe((users: TUser[]) => {
            this.users = this.usersService.sort(users);
            // this.users = users.sort((a, b) => {
            //     const aFullname = a.firstName + ' ' + a.lastName;
            //     const bFullname = b.firstName + ' ' + b.lastName;
            //     if (aFullname < bFullname) {
            //         return -1;
            //     } else if (aFullname > bFullname) {
            //         return 1;
            //     } else {
            //         return 0;
            //     }
            // });
            this.usersDefinedStr = this.utilsService.
                useSingularOrPlural(this.users.length, 'user defined.', 'users defined.');
        });
        this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.usersSubscription.unsubscribe();
    }

    public initMoreMenu(): void {
        this.pushPopoverMenuItem('Show Tour', 'show-users-tour');
    }

    public onAddUserClick() {
        this.router.navigateByUrl(`managerSettings/users/user`);
    }

    public onUserClick(uid: string): void {
        this.router.navigateByUrl(`/managerSettings/users/user/${uid}`);
    }

    public getRoleTitle(role: TRole): string {
        return this.utilsService.getRoleTitle(role);
    }

    public async confirmDeleteUser(user) {
        if (user.uid === this.sessionService.getUsersUid()) {
            await this.uxHelperService.showAlert('Alert', 'You are not allowed to delete the current logged in user.');
            return;
        }

        const fullName = user.firstName + ' ' + user.lastName;
        const question = 'Are you sure you want to delete: ' + fullName + '?';
        const response = await this.uxHelperService.showAlert('Confirm Delete', question);
        if (response.okay) {
            try {
                await this.uxHelperService.showSpinner('Deleting.');
                await this.deleteUser(user);
                await this.uxHelperService.hideSpinner();
                const msg = 'Success. ' + fullName + ' ' + 'has been deleted!';
                this.uxHelperService.showToast(msg);
            } catch (err) {
                await this.uxHelperService.hideSpinner();
                const errorMessage = this.utilsService.extractError(err);
                await this.uxHelperService.showAlert('Error!', errorMessage);
            }
        }
    }

    // A successful delete requires that the user be deleted from:
    // 1) UserAccountMap - to disassociate the user from the dealership.
    // 2) Users - to disassociate the user from the dealership
    // 3) Auth - to prevent further logins
    private async deleteUser(user) {
        const email = user.email;

        await this.userAccountMapsService.delete(user.uid);
        await this.usersService.delete(user.uid);
        await this.firebaseFunctionsService.deleteUser(email);
    }
}
